export const CREATE_REQUEST = "CREATE_REQUEST";

export const createRequest = (key, data) => {
    return dispatch => {
        dispatch({ type: CREATE_REQUEST, key: key, data: data });
    };
};